import * as React from "react";
import { Dialog, DialogType, DialogFooter } from "@fluentui/react";
import { PrimaryButton, DefaultButton } from "@fluentui/react";
import { getId } from "@fluentui/react";
import { ContextualMenu } from "@fluentui/react";

export class ModalDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hideDialog: true,
      isDraggable: false,
      displayConfirmButton: true,
    };

    this._labelId = getId("dialogLabel");
    this._subTextId = getId("subTextLabel");

    this._dragOptions = {
      moveMenuItemText: "Move",
      closeMenuItemText: "Close",
      menu: ContextualMenu,
    };
  }

  render() {
    const { hideDialog, isDraggable } = this.state;
    const {
      title,
      text,
      displayConfirmButton,
      buttonName,
      btnPrimary,
      children,
    } = this.props;

    const isTextString = typeof text === "string";

    return (
      <div>
        <DefaultButton
          primary={btnPrimary}
          onClick={this._showDialog}
          text={buttonName}
        />
        <Dialog
          hidden={hideDialog}
          onDismiss={this._closeDialog}
          dialogContentProps={{
            type: DialogType.normal,
            title: title,
            subText: isTextString ? text : undefined,
          }}
          modalProps={{
            titleAriaId: this._labelId,
            subtitleAriaId: this._subTextId,
            isBlocking: false,
            styles: { main: { maxWidth: 450 } },
            dragOptions: isDraggable ? this._dragOptions : undefined,
          }}
        >
          {/* Jeśli text to JSX, wyrenderuj go tutaj, w divie z aria */}
          {/* {!isTextString && <div id={this._subTextId}>{text}</div>} */}
          {!isTextString && React.isValidElement(text) ? (
            React.cloneElement(text, { closeDialog: this._closeDialog })
          ) : (
            <div id={this._subTextId}>{text}</div>
          )}

          {children &&
            React.isValidElement(children) &&
            React.cloneElement(children, {
              closeDialog: this._closeDialog,
            })}

          <DialogFooter>
            {displayConfirmButton && (
              <PrimaryButton onClick={this._confirm} text="Confirm" />
            )}
            <DefaultButton onClick={this._closeDialog} text="Cancel" />
          </DialogFooter>
        </Dialog>
      </div>
    );
  }

  _confirm = () => {
    if (this.props.actionConfirmed) {
      this.props.actionConfirmed();
    }
    this.setState({ hideDialog: true });
  };

  _showDialog = () => {
    this.setState({ hideDialog: false });
    if (this.props.onClick) {
      this.props.onClick();
    }
  };

  _closeDialog = () => {
    this.setState({ hideDialog: true });
    if (this.props.onCancel) {
      this.props.onCancel();
    }
  };

  _toggleDraggable = () => {
    this.setState({ isDraggable: !this.state.isDraggable });
  };
}



// WEBPACK FOOTER //
// ./src/components/formFields/Dialog.js